import { render } from "./AddInfoFooterPage.vue?vue&type=template&id=a3420ade&ts=true"
import script from "./AddInfoFooterPage.vue?vue&type=script&lang=ts"
export * from "./AddInfoFooterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__